import React from 'react';
import ReactDOM from 'react-dom';

import type { Initializer } from 'common/types/initializers';
import { Reconnect } from 'src/federation/Reconnect';
import { getOrAppendChild } from 'utilities/DOM/getOrAppendChild';

export const ClientEditDetailsDialogInitializer = (props: {
  onClose: () => void;
  onSaveSuccess: (updatedClient: {
    id: number;
    name: string;
    phone: string;
    emailAddress: string;
    notes: string;
  }) => void;
  clientId: number;
}): Initializer => {
  const node = getOrAppendChild({
    id: 'client-edit-details-dialog',
    parentNode: document.body,
  });

  const destroy = () => ReactDOM.unmountComponentAtNode(node);
  const onClose = () => {
    props.onClose();
    destroy();
  };

  return {
    destroy: () => ReactDOM.unmountComponentAtNode(node),
    render: () => {
      ReactDOM.render(
        <Reconnect
          name="ClientEditDetailsDialog"
          props={{
            onClose,
            onSaveSuccess: props.onSaveSuccess,
            clientId: props.clientId,
            notifyFn: Wahanda.ToastNotifications.sendMessage,
          }}
        />,
        node,
      );
    },
  };
};
